/**
 * @description Can be swapped with the primary gray color.
 */

const grayBlue = {
  25: "#FCFCFD",
  50: "#F8F9FC",
  100: "#EAECF5",
  200: "#D5D9EB",
  300: "#AFB5D9",
  400: "#717BBC",
  500: "#4E5BA6",
  600: "#3E4784",
  700: "#363F72",
  800: "#293056",
  900: "#101323",
  950: "#0D0F1C",
};

export default grayBlue;
